import styled from 'styled-components'
import { spacing } from '@chegg-ui/theme'
import SourceSearchBar from '@chegg-wt/core/components/CitationSearchInput/SourceSearchBar'

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 60vh;
`
export const StyledSourceSearchBar = styled(SourceSearchBar)`
  margin-bottom: ${spacing.px12};
`
